<template>
  <template v-if="loading">
    <v-col
      cols="12"
      md="4"
      lg="3"
      sm="6"
      v-for="(post, index) in posts"
      :key="index"
    >
      <div
        v-if="posts && posts.length > 0"
        class="card px-1 py-2"
        style="border: 2px solid #1f666a"
      >
        <div class="card-body border-0">
          <div class="user-info">
            <div class="user-image d-flex align-center">
              <div class="position-relative">
                <img
                  v-if="post?.userimage == ''"
                  class="user-avatar"
                  :src="post?.userimage"
                  alt=""
                />
                <img
                  v-else
                  :src="defaultposts.userimage"
                  class="user-avatar"
                  alt=""
                />
                <img
                  v-if="post?.platform == 'facebook'"
                  class="social-icon"
                  src="@/assets/images/icons/facebook.svg"
                  alt=""
                />
                <img
                  v-if="post?.platform == 'instagram'"
                  class="social-icon"
                  src="@/assets/images/icons/instagram.svg"
                  alt=""
                />
              </div>
              <div class="date-of-publish">
                <p class="single-line-text">{{ post?.page_name }}</p>
                <span v-if="post.platform === 'facebook'" class="d-block">
                  {{ formatReadableDate(post.created_time) }}
                </span>

                <span v-if="post.platform === 'instagram'" class="d-block">
                  {{ formatReadableDate(post.timestamp) }}
                </span>
              </div>
            </div>

            <Dollar />
          </div>
          <div class="post-descript mt-5 mb-3">
            <p style="min-height: 2rem; max-height: 2rem; overflow: hidden">
              {{ (post?.message || post?.caption || "").slice(0, 100) }}
              <span v-if="(post?.message || post?.caption || '').length > 100"
                >...</span
              >
            </p>
          </div>
          <div class="post-image">
            <div class="post-img-wrapper" v-if="post?.media_type == 'image'">
              <img
                :src="post?.full_picture || defaultposts.image"
                class="post-img"
                alt="post image"
              />
            </div>
            <VideoThumbnail
              v-else-if="post?.media_type === 'video'"
              :videoUrl="post?.full_picture"
              :defaultThumbnail="defaultposts.image"
            />
            <div
              class="post-img-wrapper"
              v-if="post?.media_type == 'carousel_album'"
            >
              <img
                :src="post?.full_picture || defaultposts.image"
                class="post-img"
                alt="post image"
              />
            </div>
          </div>
          <div class="card-footer mt-3">
            <div class="results">
              <div class="d-flex align-center mb-2 justify-space-between">
                <p>{{ $t("total_impressions") }}</p>
                <span v-if="post?.insights?.total_impressions">{{
                  post?.insights?.total_impressions
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="d-flex align-center mb-2 justify-space-between">
                <p>{{ $t("total_engagements") }}</p>
                <span v-if="post?.insights?.total_engagements">{{
                  post?.insights?.total_engagements
                }}</span>
                <span v-else>0</span>
              </div>
              <div class="d-flex align-center mb-2 justify-space-between">
                <p v-if="post?.platform === 'facebook'">{{ $t("total_clicks") }}</p>
                <p v-else>{{ $t("total_saves") }}</p>
                <span v-if="post?.insights?.total_clicks">{{
                  post?.insights?.total_clicks
                }}</span>
                <span v-else>0</span>
              </div>
            </div>
            <div class="card-footerx">
              <router-link
                class="flex-grow-1"
                :to="`/post/${post?.id}/instagram/engagement-insights`"
              >
                <v-btn class="preview-btn" variant="outlined"
                  >{{ $t("preview") }}</v-btn
                ></router-link
              >
              <router-link
                :to="`/post/edit/${post?.id}/instagram/engagement-insights`"
              >
                <button class="edite-post">
                  <Edithome /></button
              ></router-link>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <v-col cols="12">
          <div class="text-center my-5">
            <p>لا توجد بيانات</p>
          </div>
        </v-col>
      </div>
    </v-col>
  </template>
  <!-- Skeleton Loader -->
  <template v-else>
    <v-col cols="12" md="4" lg="3" sm="6" v-for="n in 4" :key="'skeleton-' + n">
      <v-skeleton-loader
        class="mx-auto border"
        max-width="300"
        type="image, article"
      ></v-skeleton-loader>
    </v-col>
  </template>
</template>
<script>
import Edithome from "@/components/icons/posts/Edithome.vue";
import Dollar from "@/components/icons/posts/Dollar.vue";
import VideoThumbnail from "@/components/home/VideoThumbnail.vue";
export default {
  components: {
    Edithome,
    Dollar,
    VideoThumbnail,
  },
  props: {
    posts: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      defaultposts: {
        username: "Ahmed hamdi",
        time: "12/10/2024",
        platformimage: require("@/assets/images/icons/facebook.svg"),
        userimage: require("@/assets/soft-ware-img/Shape.png"),
        description:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy",
        image: require("@/assets/images/postimage.png"),
        Impressions: 230,
        Engagement: 520,
        Clicks: 1203,
      },
    };
  },
  methods: {
    formatReadableDate(datetime) {
      if (!datetime) return "";
      const date = new Date(datetime);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      return date.toLocaleDateString("ar-EG", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
    },
  },
};
</script>
<style scoped>
.post-img {
  height: 305px;
  max-height: 305px;
  min-height: 305px;
}
.posts-scheduled .card .card-body .post-descript p {
  text-align: left;
}
.posts-scheduled .card .card-body .user-info .date-of-publish span {
  text-align: left;
}
.card-footerx {
  display: flex;
  align-items: center;
  gap: 12px;
}

.preview-btn {
  font-size: 13px;
  padding: 4px 1rem;
  text-transform: none;
  border-color: #237276;
  color: #237276;
  border-radius: 8px;
  width: 100%;
}

.action-icon {
  font-size: 18px;
  color: #237276;
  cursor: pointer;
}
.single-line-text {
  display: block;
  max-width: 180px; /* أو حسب التصميم */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  color: #333;
}
</style>
